


































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Incident } from '@/modules/tickets/incidents/shared/domain/incident';
import moment from 'moment';

@Component({
    name: 'incidents-drawer',
})
export default class IncidentDrawer extends Vue {
    private drawer = true;
    private colors = ['green', 'blue', 'yellow', 'orange', 'purple'];
    private filterWord: string = '';

    @Prop({ type: Array, default: () => [] })
    incidents!: Incident[];

    getDate(strDate: string) {
        return moment(strDate)
            .locale('es')
            .format('DD [de] MMMM [de] YYYY, hh:mm:ss a');
    }

    getName(s: string) {
        const words = s.split('-');
        return words[1] + ' ' + words[2];
    }

    get filteredIncidents() {
        return this.incidents.filter(incident =>
            this.getName(incident.name)
                .toLocaleLowerCase()
                .includes(this.filterWord.toLocaleLowerCase()),
        );
    }
}
